



































































import { PageCategory } from '~/types/PageCategory'
import ProductDetails from '~/components/ProductDetails.vue'
import AddToCartAction from "~/components/ProductActions/AddToCartAction.vue";
import AddToCart from "~/components/AddToCart";
import {useAddToCart} from "~/composables/useAddToCart";
import CancelOrderItemModal from '~/modules/customer/components/Orders/Cancelation/CancelOrderItemModal.vue'
import {computed, PropType, ref} from "@nuxtjs/composition-api";
import {ProductInterface} from "~/modules/GraphQL/types";
import {useProductActions} from "~/composables";
import {ActionType} from "~/types/Action";
import {OrderDeliveryStatus} from "~/types/orders/OrdersCategories";
import {focusTrap} from '@storefront-ui/vue/src/utilities/directives/focus-trap/focus-trap-directive.js'
import {clickOutside} from '@storefront-ui/vue/src/utilities/directives/click-outside/click-outside-directive.js'

export default {
  name: 'DsbOrderDetailItem',
  components: {
    ProductDetails,
    AddToCartAction,
    AddToCart,
    CancelOrderItemModal
  },
  directives: {
    focusTrap,
    clickOutside
  },
  props: {
    sku: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    text: {
      type: String,
    },
    imgSrc: {
      required: true,
      type: String,
    },
    details: {
      required: true,
      type: Array,
    },
    product: {
      type: Object as PropType<ProductInterface>
    },
    orderItem: {
      type: Object
    }
  },
  setup (props) {
    const product = computed(() => props.product);
    const {actions} = useProductActions(product)

    function getAction(type: ActionType) {
      return actions.value.get(type)
    }

    const openCancelOrderItemModal = ref(false)
    const cancelOrderItemPreview = ref({})

    const confirmCancelOrderItem = (orderItem) => {
      cancelOrderItemPreview.value = orderItem
      openCancelOrderItemModal.value = true
    }

    const closeCancelOrderItemModal = () => {
      openCancelOrderItemModal.value = false
    }

    const isCancelOrderItemButtonActive = (status) => {
      return (status === OrderDeliveryStatus.ORDERED
        || status === OrderDeliveryStatus.INVOICED
        || status === OrderDeliveryStatus.PENDING
      )
    }

    return {
      ...useAddToCart(props.sku, product),
      PageCategory,
      ActionType,
      getAction,
      isCancelOrderItemModalVisible : computed(() => {return openCancelOrderItemModal.value}),
      isCancelOrderItemButtonActive,
      cancelOrderItemPreview,
      confirmCancelOrderItem,
      closeCancelOrderItemModal
    }
  },
}
